import React from 'react';
import { PrebookingRow } from 'modules/prebookings';
import { groupPrebookingsByDate } from 'modules/prebookings/utils';
import ReactTooltip from 'react-tooltip';

const PrebookingTable = ({ prebookings, onLaunch }) => {
  const prebookingsGroupedByTime = (prebookings || []).reduce(groupPrebookingsByDate, {});

  return Object.keys(prebookingsGroupedByTime).map((date) => {
    return (
      <div key={date}>
        <h2>{date}</h2>
        <table width="100%" cellPadding="0" cellSpacing="0">
          {prebookingsGroupedByTime[date].map((prebooking) => (
            <PrebookingRow key={prebooking.id} prebooking={prebooking} onLaunch={onLaunch} />
          ))}
        </table>
        <ReactTooltip type="light" id="prebookingsListTooltip" />
      </div>
    );
  });
};

export default PrebookingTable;
